<template>
  <div class="tkList full-height linear-main3">
    <ld-header
      :transparent="true"
      :white="true"
      @click-left="back"
    >
      <span
        v-show="tkSearchInfo.queryStrWF.travelType == 2 && !firstFlight"
      >{{ $t('C174', '去程') }}：</span>
      <span
        v-show="tkSearchInfo.queryStrWF.travelType == 2 && firstFlight"
      >{{ $t('C175', '返程') }}：</span>
      {{ tkSearchInfo.depport.cityName }} ⇀ {{ tkSearchInfo.arrport.cityName }}
    </ld-header>

    <!-- 日期选择栏 -->
    <list-date
      :date-info="formatDate(tkSearchInfo.queryStrWF.departDate)"
      @afterDay="changeDate"

      @prevDay="changeDate"
      @toggle="showDate"
    />


    <!--显示第一程-->
    <div
      v-if="firstFlight"
      class="firstFlight"
    >
      <van-cell
        class="round-sm"
        is-link
        @click="showPlanes = true"
      >
        <span>去</span> &nbsp;{{ tkSearchInfo.flights[0].departDate }}
        {{ tkSearchInfo.flights[0].departDate | week }}
        {{ tkSearchInfo.flights[0].departTime }}
        {{ tkSearchInfo.flights[0].airlineName }} |
        {{ tkSearchInfo.flights[0].flightNo }}
      </van-cell>

      <van-popup
        v-model="showPlanes"
        :close-on-popstate="true"
        class="popup-width"
      >
        <voyage
          :flights="[tkSearchInfo.flights[0]]"
          round-trip="0"
          travel-type="2"
        />
      </van-popup>
    </div>

    <!--  -->
    <travel-tips
      v-if="tkSearchInfo.arrport.cityId"
      ref="traveltips"
      :arrive-cityid="tkSearchInfo.arrport.cityId"
      :auto-popup="false"
      :depport-cityid="tkSearchInfo.depport.cityId"
      cplx="10901"
      @close="closeTravelTips"
    />

    <!--  -->
    <div class="tkListwrapper" v-if="defeatedshow">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <div class="list">
          <!-- 推荐火车 -->
          <transition name="van-slide-bottom">
            <div
              v-if="tkSearchInfo.train.trainCode"
              class="pad-b-5"
            >
              <van-cell class="bor-radus line-height-normal">
                <van-row
                  align="center"
                  type="flex"
                  @click="toTrainList"
                >
                  <van-col span="2">
                    <img
                      src="~Assets/images/tr/train_icon.png"
                      width="22"
                    >
                  </van-col>
                  <van-col span="15">
                    <van-row>
                      <van-col
                        class="text-left"
                        span="8"
                      >
                        <div class="font20 black text-space-1">
                          {{ tkSearchInfo.train.startTime }}
                        </div>
                        <div class="font12 pad gray">
                          {{ tkSearchInfo.train.fromStationName }}
                        </div>
                      </van-col>
                      <van-col
                        class="text-center font10 text-nowrap gray pad-t-6"
                        span="8"
                      >
                        <div>{{ tkSearchInfo.train.runTime }}</div>
                        <icon-arrow-line />
                      </van-col>
                      <van-col
                        class="text-right"
                        span="8"
                      >
                        <div class="font20 black text-space-1">
                          {{ tkSearchInfo.train.arriveTime }}
                        </div>
                        <div class="font12 pad gray">
                          {{ tkSearchInfo.train.toStationName }}
                        </div>
                      </van-col>
                    </van-row>
                  </van-col>
                  <van-col
                    class="text-right"
                    span="7"
                  >
                    <div class="font-lg money-color text-space-1">
                      <span class="font10">&yen;</span>
                      <span class="font20">{{
                        tkSearchInfo.train.seatList.price
                      }}</span>
                    </div>
                    <span class="gray font12">{{
                      tkSearchInfo.train.seatList.seatName
                    }}</span>
                  </van-col>
                </van-row>
              </van-cell>
            </div>
          </transition>

          <!-- 航班列表 -->
          <div
            v-for="(info, index1) in flightMap"
            :key="index1"
          >
            <transition name="van-slide-right">
              <div
                v-show="info.isShow"
                :key="index1"
                class="pad-b-5"
                @click="toCabin(info)"
              >
                <flight
                  :arr-set="arrSet"
                  :flight-obj="info"
                />
              </div>
            </transition>
          </div>

          <!-- description="指定日期没有可用航班!" -->
          <ld-no-more v-show="flightMap.length" />
          <div class="asfdsdgfhmg" />
          <!-- 样式控制七个二 -->
          <ld-call-service
            v-if="
              loginConfig &&
                loginConfig.pageName &&
                loginConfig.pageName.indexOf('柒个贰') > -1
            "
            from="10901"
          />
        </div>
      </mescroll-vue>
    </div>
    <div class="width_padd" v-else>
      <span class="font_col_ss">{{ tisdefeated }}</span>
    </div>


    <!-- 底部菜单 -->
    <ld-tabbar>
      <!-- 时间筛选 -->
      <van-row
        align="center"
        class="text-center bg-white shadow full-width font12"
        type="flex"
      >
        <van-col
          span="8"
          @click="fliters(1)"
        >
          <ld-icon
            :icon-class="v == 1 || v == 2 ? 'linear-main2' : 'bg-mediumGray'"
            class="icon"
            gradient
            type="iconico_home_committed"
          />
          <div :class="{ 'main-color': v == 1 || v == 2 }">
            {{ $t('F031', '时间') }}
            <span v-show="v == 2">{{ $t('czdw', '早-晚') }}</span>
            <span v-show="v == 1">{{ $t('cwdz', '晚-早') }}</span>
          </div>
        </van-col>
        <!-- 价格高低 -->
        <van-col
          span="8"
          @click="fliters(2)"
        >
          <ld-icon
            :icon-class="v == 3 || v == 4 ? 'linear-main2' : 'bg-mediumGray'"
            class="icon"
            gradient
            type="iconjiage"
          />
          <div :class="{ 'main-color': v == 3 || v == 4 }">
            {{ $t('H020', '价格') }}
            <span v-show="v == 4">低-高</span>
            <span v-show="v == 3">高-低</span>
          </div>
        </van-col>
        <van-col
          span="8"
          @click="showFliter"
        >
          <ld-icon
            :icon-class="
              timearr.length ||
                deparr.length ||
                arrarr.length ||
                cabinarr.length ||
                hkgsarr.length
                ? 'linear-main2'
                : 'bg-mediumGray'
            "
            class="icon"
            gradient
            type="iconshaixuan1"
          />
          <div
            :class="{
              'main-color':
                timearr.length ||
                deparr.length ||
                arrarr.length ||
                cabinarr.length ||
                hkgsarr.length,
            }"
          >
            {{ $t('C121', '筛选') }}
          </div>
        </van-col>
      </van-row>
    </ld-tabbar>
    <van-popup
      v-model="fliterIsShow"
      :close-on-popstate="true"
      class="filter-panel"
      position="bottom"
    >
      <van-tree-select
        :items="items"
        :main-active-index.sync="index"
      >
        <template slot="content">
          <!-- 时间 -->
          <div v-show="index == 0">
            <van-cell-group>
              <van-cell :title="$t('F223', '不限')">
                <van-checkbox
                  slot="right-icon"
                  v-model="nolimitobj.seltime"
                  @click="nolimit('seltime', nolimitobj.seltime)"
                />
              </van-cell>
              <van-cell
                v-for="(t, index2) in depTime"
                :key="index2"
                :title="t.name"
              >
                <van-checkbox
                  slot="right-icon"
                  v-model="t.checked"
                  @change="getTerm(0, t.name, t.checked)"
                />
              </van-cell>
            </van-cell-group>
          </div>
          <!-- 起飞降落 -->
          <div v-show="index == 1">
            <van-cell> {{ $t('Form', '起飞') }}</van-cell>
            <van-cell-group>
              <van-cell :title="$t('F223', '不限')">
                <van-checkbox
                  slot="right-icon"
                  v-model="nolimitobj.seldepPlane"
                  @click="nolimit('seldepPlane', nolimitobj.seldepPlane)"
                />
              </van-cell>
              <van-cell
                v-for="(t, index3) in depPlane"
                :key="'b' + index3"
                :title="t.name"
              >
                <van-checkbox
                  slot="right-icon"
                  v-model="t.checked"
                  @change="getTerm(1, t.name, t.checked)"
                />
              </van-cell>
            </van-cell-group>

            <van-cell> 降落</van-cell>
            <van-cell-group>
              <van-cell :title="$t('F223', '不限')">
                <van-checkbox
                  slot="right-icon"
                  v-model="nolimitobj.selarrPlane"
                  @click="nolimit('selarrPlane', nolimitobj.selarrPlane)"
                />
              </van-cell>
              <van-cell
                v-for="(t, index4) in arrPlane"
                :key="'c' + index4"
                :title="t.name"
              >
                <van-checkbox
                  slot="right-icon"
                  v-model="t.checked"
                  @change="getTerm(2, t.name, t.checked)"
                />
              </van-cell>
            </van-cell-group>
          </div>

          <div v-show="index == 2">
            <van-cell-group>
              <van-cell :title="$t('F223', '不限')">
                <van-checkbox
                  slot="right-icon"
                  v-model="nolimitobj.selhkgs"
                  @click="nolimit('selhkgs', nolimitobj.selhkgs)"
                />
              </van-cell>
              <van-cell
                v-for="(h, index6) in hkgs"
                :key="index6"
                :title="h.name"
              >
                <van-checkbox
                  slot="right-icon"
                  v-model="h.checked"
                  @change="getTerm(4, h.name, h.checked)"
                />
              </van-cell>
            </van-cell-group>
          </div>
          <!-- <div
            v-show="index==3"
          >
            <van-checkbox
              v-model="nolimitobj.selcabin"
            >
              不限
            </van-checkbox>
            <van-checkbox
              v-for="(t,index5) in canbin"
              :key="'d'+index5"
              v-model="t.checked"
              @change="getTerm(3,t.name,t.checked)"
            >
              {{ t.name }}
            </van-checkbox>
          </div> -->
        </template>
      </van-tree-select>
      <!-- 展示时间等其他东西 -->
      <div class="nav">
        <div class="navlist flexStyle">
          <span
            v-for="(item0, index0) in list0"
            :key="index0.id"
            class="contentStyle"
          >
            {{ item0 }}
          </span>
          <span
            v-for="(item1, index1) in list1"
            :key="index1.id"
            class="contentStyle"
          >
            {{ item1 }}
          </span>
          <span
            v-for="(item2, index2) in list2"
            :key="index2.id"
            class="contentStyle"
          >
            {{ item2 }}
          </span>
          <span
            v-for="(item4, index4) in list4"
            :key="index4.id"
            class="contentStyle"
          >
            {{ item4 }}
          </span>
        </div>
      </div>
      <van-row class="filter-panel__reset">
        <ld-button
          class="reset"
          @click.native="clearing"
        >
          重置筛选
        </ld-button>
        <ld-button
          class="selection bg-main"
          @click.native="ensure"
        >
          {{ $t('Display', '显示结果') }}
        </ld-button>
      </van-row>
    </van-popup>
    <ld-calendar
      ref="date"
      end-text="回程"
      start-text="去程"
      @selected="getDate"
    />
  </div>
</template>

<script>
import MescrollVue from 'mescroll.js/mescroll.vue'
import ldNoMore from 'Common/ldNoMore'
import {mapGetters, mapActions} from 'vuex'
import {TreeSelect, Popup, Checkbox, Cell, CellGroup, Icon, Empty} from 'vant'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import flight from 'Components/tk/flight'
import listDate from 'Components/tk/listDate'
import voyage from 'Components/tk/voyage'
import iconArrowLine from 'Common/iconArrowLine'

import ldHeader from 'Common/ldHeader/index'
import ldButton from 'Common/ldButton'
import {objToArr, arrToObj} from 'Utils/object.js'
import {formatDate, getOneWeek} from 'Utils/dateUtil'
import ldCallService from 'Components/ldCallService'
import travelTips from 'Components/travelTips'
import {queryVipParameter} from 'Utils/publicApi'
import defaultMixin from '@/business/mixins/default'

import {localget, localset} from 'Utils/storage'
import {goXlHome,isXlminp} from 'Utils/xltools'

export default {
  name: 'TkList',
  mixins: [defaultMixin],
  components: {
    MescrollVue,
    ldHeader,
    ldButton,
    ldNoMore,
    flight,
    [TreeSelect.name]: TreeSelect,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    [Popup.name]: Popup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [Empty.name]: Empty,
    ldTabbar,
    listDate,
    voyage,
    iconArrowLine,
    ldCalendar: () => import('Common/ldCalendar'),
    ldCallService,
    travelTips
  },
  data() {
    return {
      flag: null,
      creaLinst: [],
      list0: [],
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      setDepartAirportName: [],
      arrSet: [],
      down: {use: false},
      showPlanes: false,
      // weekPrice: [], //一周特价
      flightMap: [], //航班
      priceMap: {}, //价格
      violateList: {}, //违背事项
      fliterIsShow: false, //显示过滤
      depTime: [
        {name: '00:00-06:00', checked: false},
        {name: '06:00-12:00', checked: false},
        {name: '12:00-18:00', checked: false},
        {name: '18:00-24:00', checked: false},
      ],
      canbin: [
        {name: '经济舱', checked: false},
        {name: '头等舱/公务舱', checked: false},
      ],
      hkgs: [],
      arrPlane: {},
      depPlane: {},
      index: 0,
      v: 2,
      nolimitobj: {
        seltime: true,
        seldepPlane: true,
        selarrPlane: true,
        selcabin: true,
        selhkgs: true,
      },
      items: [{text: '起飞时间'}, {text: '机场'}, {text: '航空公司'}],
      timearr: [],
      deparr: [],
      arrarr: [],
      cabinarr: [],
      hkgsarr: [],
      cabinInfo: {},
      showCache: false,
      showComparePriceTag: false,
      saerchStyle: false,
      refreshComparePriceTimer: null,
      tisdefeated:"",
      defeatedshow:true,
    }
  },
  computed: {
    // 使用对象展开运算符将 getter 混入 computed 对象中
    ...mapGetters({
      tkSearchInfo: 'tk/tkSearchInfo',
      travelerList: 'tk/travelerList',
      pageCtrl: 'tk/pageCtrl', //页面控制信息
      tripType: 'tripType',
      trSearchInfo: 'tr/trSearchInfo',
      userInfo: 'userInfo',
      flightCache: 'tk/flightCache',
      loginConfig: 'loginConfig'
    }),
    firstFlight() {
      //显示第一程航班信息
      if (this.tkSearchInfo.roundtrip == 1 && this.tkSearchInfo.flights[0]) {
        return true
      }
      return false
    },
    weekPrice() {
      return getOneWeek(this.tkSearchInfo.queryStrWF.departDate.date)
    },
  },
  // beforeRouteLeave (to, from, next) {
  // 	// 导航离开该组件的对应路由时调用
  // 	// 可以访问组件实例 `this`
  // 	next()
  // },
  beforeDestroy() {
    clearInterval(this.flag) //关闭
    if (this.refreshComparePriceTimer) {
      clearInterval(this.refreshComparePriceTimer)
      this.refreshComparePriceTimer = null
    }
  },

  updated() {
    setTimeout(() => {
      clearInterval(this.flag)
    }, 6000)

  },
  created() {
    console.log('this', this)
    this.getComparePrice()
    if (this.tkSearchInfo.queryStrWF.travelType == 2 && this.firstFlight) {
      this.ensure()
    }
    //2往返程 空或1单程 ,
    if (this.tkSearchInfo.queryStrWF.travelType == 2 && this.tkSearchInfo.roundtrip == 1) {// 0 单程 1 往返 2需求单
      // let arr = this.tkSearchInfo.queryStrWF.arriveAirport
      // this.tkSearchInfo.queryStrWF.arriveAirport = this.tkSearchInfo.queryStrWF.departAirport
      // this.tkSearchInfo.queryStrWF.departAirport = arr
      // this.tkSearchInfo.queryStrWF.departDate = this.tkSearchInfo.queryStrWF.arriveDate;
      // [this.tkSearchInfo.depport, this.tkSearchInfo.arrport] = [this.tkSearchInfo.arrport, this.tkSearchInfo.depport]
      if (Object.keys(this.flightCache).length) {
        if (this.tkSearchInfo.flights.length == 2) {
          this.showCache = true
          this.getResult(this.flightCache)
          return
        }
      }
      this.search()
      this.getParams()
    } else {
      // if (Object.keys(this.flightCache).length) {
      //   this.showCache = true
      //   this.getResult(this.flightCache)
      // } else {
      this.search()
      this.getParams()
      // }
    }
  },
  methods: {
    formatDate,
    ...mapActions({
      getParams: 'tk/getParams', //*10914 航班查询时，以弹窗形式提示 全天最低价 20019 机票查询时，是否展示推荐高铁/动车二等座
    }),
    //查询
    search() {
      try {
        this.$api['tkQuery/queryFlightMinPrice'](
          this.tkSearchInfo.queryStrWF
        ).then((res) => {
          if(res.errCode=='999' || res.errMsg=='"查询航班列表失败!"'){
            this.tisdefeated=res.tips
            this.defeatedshow=false
            return
          }
          this.cache = res.data.cacheId
          let cache = res.data || {}
          this.$store.commit('tk/setFlightCache', cache)
          this.getResult(cache)
          this.tkSearchInfo.queryStrWF.cacheId = this.cache
          this.flitersFun()
          this.ensure()
        })
      } catch (error) {
        console.log(error)
      }
    },
    getResult(cache) {
      let flight = objToArr(cache.flightMap)
      flight.forEach(function (item) {
        item.isShow = true
      })
      this.flightMap = flight
      this.cacheId = cache.cacheId
      // this.fliters(1) //按时间排序
      this.depPlane = this.getplane(0)
      this.arrPlane = this.getplane(1)
      this.hkgs = this.getplane(2)
      // 20201118 16:35 周欣念 没原因 无脑加
      // 2021年5月18日18:29:53 周欣念 如果返回的只有一个航班，就不展示
      if (this.tkSearchInfo.showMinPriceTips && flight.length > 1) {
        if (this.showCache) {
          return
        }
        var str = this.tkSearchInfo.depport.cityName + '-' +
          this.tkSearchInfo.arrport.cityName + ' ' + this.tkSearchInfo.departDate.date +
          ' 的最低价航班为：' + cache.dayMinPrice.departTime + ' / ' + cache.dayMinPrice.flightNo +
          ' ￥' + (cache.dayMinPrice.fcny || cache.dayMinPrice.salePrice) + ',请优先选择最低价航班。'
        this.$dialog.alert({
          title: '当天最低价',
          message: str,
        })
      }
      if (this.showComparePriceTag) { //银联商旅
        this.refreshComparePrice()
        if (this.saerchStyle) {
          this.getInfo()
        }
      }
      for (let i in this.flightMap) {
        this.setDepartAirportName[i] = this.flightMap[i].departAirportName
      }
      // const set1 = new Set(this.setDepartAirportName)
      this.arrSet = [...new Set(this.setDepartAirportName)]

    },
    getInfo() {
      try {
        this.$api['tkQuery/getCtripCacheInfo']({
          arriveAirport: this.tkSearchInfo.queryStrWF.arriveAirport,
          departAirport: this.tkSearchInfo.queryStrWF.departAirport,
          departDate: this.tkSearchInfo.queryStrWF.departDate,
          cacheId: this.cacheId
        }).then((res) => {
          if (res.errCode == '1') {
            this.refreshComparePrice()
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    gerInfo_l() {
      try {
        this.$api['tkQuery/queryCtripFlightMinPrice'](
          this.tkSearchInfo.queryStrWF
        ).then((res) => {
          if (res.errCode === '1' && this.saerchStyle) {
            this.getInfo()
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    //获取比价标记
    async getComparePrice() {
      //OBT、H5是否展示列表比价价格标签 0否 1是 默认0
      await queryVipParameter('11601028').then(res => {
        this.showComparePriceTag = res.value1 == '1'
      })
      await queryVipParameter('11601032').then(res => {
        this.saerchStyle = res.value1 == '1'
      })
    },
    refreshComparePrice() {
      // this.refreshComparePriceTimer = setInterval(() => {
      if (this.cacheId) {
        if (this.flightMap.length > 0) {
          let minPriceParam = {
            cacheId: this.cacheId,
            flightNo: '',
            cabinType: this.tkSearchInfo.queryStrWF.cabinType
          }
          this.$api['tkQuery/queryCtripFlightMinPrice'](minPriceParam).then((res) => {
            let cache = res.data || {}
            if (cache.flightMap) {
              for (let i = 0; i < this.flightMap.length; i++) {
                let flight = this.flightMap[i]
                if (cache.flightMap[flight.flightNo] && cache.flightMap[flight.flightNo].priceMap) {
                  let priceMap = cache.flightMap[flight.flightNo].priceMap[0]
                  let minP = flight.salePrice
                  for (let p in priceMap) {
                    if (minP > priceMap[p]) {
                      minP = priceMap[p]
                    }
                  }
                  this.$set(flight, 'comparePriceMap', priceMap)
                  this.$set(flight, 'salePrice', minP)
                }
              }
            }
          })
        }
        // clearInterval(this.refreshComparePriceTimer)
      }
      // }, 1000);
    },
    showDate() {
      //打开日历控件
      if (this.pageCtrl.isChangeDate) {
        this.$refs.date.toggle({
          defaultDate:
            this.tkSearchInfo.roundtrip == 0
              ? this.tkSearchInfo.departDate.date
              : this.tkSearchInfo.arriveDate.date,
          minDate: this.tkSearchInfo.minDate,
          maxDate: this.tkSearchInfo.maxDate,
        })
      }
    },
    getDate(date) {
      console.log(date)
      //日期回调
      if (this.pageCtrl.isChangeDate) {
        /* 如果当前查询日期是当天或小于当天 则不能再查前一天  */
        let returnDate = date
        if (returnDate < formatDate(new Date()).date) {
          this.$toast('出发日期不能早于今天')
          return
        }
        if (this.tkSearchInfo.queryStrWF.travelType == 2) {
          if (this.tkSearchInfo.roundtrip == 1) {
            console.log(this.tkSearchInfo.arriveDate, this.tkSearchInfo.departDate)
            console.log(this.tkSearchInfo.arriveDate.date > this.tkSearchInfo.departDate.date)
            console.log(this.tkSearchInfo.arriveDate.date < this.tkSearchInfo.departDate.date)
            //返程
            if (
              returnDate < this.tkSearchInfo.departDate.date
            ) {
              this.$toast('返程日期不能小于去程日期')
              return
            } else {
              this.tkSearchInfo.arriveDate = formatDate(returnDate)
            }
          } else {
            if (returnDate > this.tkSearchInfo.arriveDate.date) {
              //如果去程大于返程 返程+1天
              this.tkSearchInfo.arriveDate = formatDate(returnDate, 1)
              this.tkSearchInfo.queryStrWF.arriveDate =
                this.tkSearchInfo.arriveDate.date
            }
            this.tkSearchInfo.departDate = formatDate(returnDate)
          }
        } else {
          this.tkSearchInfo.departDate = formatDate(returnDate)
        }
        this.tkSearchInfo.queryStrWF.departDate = returnDate
        this.search()
      }
    },
    changeDate(days) {
      //修改查询日期
      if (this.pageCtrl.isChangeDate) {
        let returnDate = ''
        if (this.tkSearchInfo.queryStrWF.travelType == 2) {
          if (this.tkSearchInfo.roundtrip == 1) {
            //如果是第二程 返程
            returnDate = formatDate(
              this.tkSearchInfo.arriveDate.date,
              days
            ).date
            if (
              returnDate <
              this.tkSearchInfo.departDate.date
            ) {
              //如果返程日期大于去程
              this.$toast('返程日期不能小于去程日期')
              return
            } else {
              this.tkSearchInfo.arriveDate = formatDate(returnDate)
              this.creaLinst = this.tkSearchInfo.arriveDate.date
            }
          } else {
            //如果是第1程
            returnDate = formatDate(
              this.tkSearchInfo.departDate.date,
              days
            ).date
            if (returnDate > this.tkSearchInfo.arriveDate.date) {
              //如果去程大于返程 返程+1天
              this.tkSearchInfo.arriveDate = formatDate(returnDate, 1)
              this.tkSearchInfo.queryStrWF.arriveDate =
                this.tkSearchInfo.arriveDate.date
            }
            if (returnDate < formatDate(new Date()).date) {
              this.$toast('出发日期不能早于今天')
              return
            } else {
              this.tkSearchInfo.departDate = formatDate(returnDate)
            }
          }
        } else {
          returnDate = formatDate(this.tkSearchInfo.departDate.date, days).date
          if (returnDate < formatDate(new Date()).date) {
            this.$toast('出发日期不能早于今天')
            return
          } else {
            if (this.pageCtrl.isChangeDateRange > 0) {
              let historyLog = localget('_historyLog')
              if (historyLog && historyLog.tk && historyLog.tk.ccsqd) {
                let dateBegin = historyLog.tk.ccsqd.dateBegin
                let dateEnd = historyLog.tk.ccsqd.dateEnd

                let minDate = formatDate(dateBegin, -this.pageCtrl.isChangeDateRange).date
                if (returnDate < minDate) {
                  this.$toast('不能超出可修改范围')
                  return
                }
                let maxDate = formatDate(dateEnd, this.pageCtrl.isChangeDateRange).date
                if (returnDate > maxDate) {
                  this.$toast('不能超出可修改范围')
                  return
                }
              }
            }
            this.tkSearchInfo.departDate = formatDate(returnDate)
          }
        }
        this.tkSearchInfo.queryStrWF.departDate = returnDate
        this.search()
      }
    },
    //选中舱位
    toCabin(info) {
      var infos = []
      infos.push(info)
      if (this.tkSearchInfo.queryStrWF.travelType == 2 && this.firstFlight) {
        const beginTime = `${this.tkSearchInfo.flights[0].arriveDate} ${this.tkSearchInfo.flights[0].arriveTime}`
        const endTime = `${infos[0].departDate} ${infos[0].departTime}`
        const st = this.getTimeDiff(beginTime, endTime)
        const stMinutes = this.getTimeDiffInMinutes(st)
        if (stMinutes < 120) {
          console.log(stMinutes)
          this.showAlert()
          return
        }
      }

      this.jump(info)
    },
    // 比较时间
    getTimeDiffInMinutes(timeDiff) {
      const [hours, minutes] = timeDiff.split('小时')
      console.log(hours, minutes)
      return parseInt(hours, 10) * 60 + parseInt(minutes, 10)
    },
    getTimeDiff(beginTime, endTime) {
      const dateBegin = new Date(beginTime)
      const dateEnd = new Date(endTime)
      const dateDiff = dateEnd.getTime() - dateBegin.getTime() // 时间差的毫秒数
      const dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)) // 计算出相差天数
      const leave1 = dateDiff % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
      const hours = Math.floor(leave1 / (3600 * 1000)) // 计算出小时数
      // 计算相差分钟数
      const leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
      const minutes = Math.floor(leave2 / (60 * 1000)) // 计算相差分钟数
      // 计算相差秒数
      const leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
      const seconds = Math.round(leave3 / 1000)
      const st = `${hours}小时${minutes}分钟`
      console.log(st)
      return st
    },
    showAlert() {
      this.$dialog.alert({
        title: '温馨提示',
        message: '请合理选择第二程航班出行时间',
      })
    },
    //关闭出行提示
    closeTravelTips() {
      if (Object.keys(this.cabinInfo).length) {
        this.jump(this.cabinInfo)
      }
    },
    //跳转 舱位列表
    jump(info) {
      try {
        let self = this
        this.$api['tkQuery/queryMoreCabin']({
          cacheId: this.cacheId,
          flightNo: info.flightNo,
          tripType: this.tripType,
          cabinType: this.tkSearchInfo.cabin,
        }).then((res) => {
          let cache = res.data || {}
          if (!cache || cache.length <= 0) {
            self.$toast('没有获取到舱位')
            return
          }
          let tkSearchInfo = self.tkSearchInfo
          tkSearchInfo.flights[self.tkSearchInfo.roundtrip] = info
          tkSearchInfo.flights[self.tkSearchInfo.roundtrip].cacheId = self.cacheId
          tkSearchInfo.flights[self.tkSearchInfo.roundtrip].planeMap = self.planeMap
          tkSearchInfo.priceMap = self.priceMap
          //tkSearchInfo.violateList=self.violateList
          tkSearchInfo.flights[self.tkSearchInfo.roundtrip].cabinTypeList = cache.cabinTypeMap
          tkSearchInfo.flights[self.tkSearchInfo.roundtrip].flightMinPrice = cache.flightMinPrice
          self.$store.commit('tk/tkSearchInfo', tkSearchInfo)
          this.$router.push({
            path: '/tk/tkCabin',
            query: {
              roundtrip: '0',
              routeId: this.$route.query.routeId,
              Transit: !!info.flyTransfer,//模拟
              GoBack: true
            }
          })
        })
      } catch (error) {
        throw error
      }
    },
    //打开筛选
    showFliter() {
      this.fliterIsShow = !this.fliterIsShow
    },
    getplane(m) {
      //获取机场  航空公司  数据
      let self = this
      if (!self.flightMap) {
        return false
      }
      let obj = []
      let obj2 = []
      switch (m) {
        case 0:
          getData('departAirportName')
          break
        case 1:
          getData('arriveAirportName')
          break
        case 2:
          getData('airlineName')
          break
      }

      function getData(m) {
        for (let ke in self.flightMap) {
          let value = self.flightMap[ke][m] || ''
          if (value !== '' && obj.indexOf(value) < 0) {
            obj.push(value)
          }
        }
        for (let i = 0; i < obj.length; i++) {
          obj2.push({name: obj[i], checked: false})
        }
      }

      return obj2
    },
    getTerm(m, n, k) {
      //获取选中数据
      switch (m) {
      //起飞时间
        case 0:
          for (let i = 0; i < this.depTime.length; i++) {
            let index = this.timearr.indexOf(n)
            if (k && index < 0) {
              this.timearr.push(n)
              this.list0 = this.timearr
            } else if (!k && index >= 0) {
              this.timearr.splice(index, 1)
            }
          }
          break
        //起飞机场
        case 1:
          for (let i = 0; i < this.depPlane.length; i++) {
            let index = this.deparr.indexOf(n)
            if (k && index < 0) {
              this.deparr.push(n)
              this.list1 = this.deparr
            } else if (!k && index >= 0) {
              this.deparr.splice(index, 1)
            }
          }
          break
        //到达机场
        case 2:
          for (let i = 0; i < this.arrPlane.length; i++) {
            let index = this.arrarr.indexOf(n)
            if (k && index < 0) {
              this.arrarr.push(n)
              this.list2 = this.arrarr
            } else if (!k && index >= 0) {
              this.arrarr.splice(index, 1)
            }
          }
          break
        //舱位类型
        case 3:
          for (let i = 0; i < this.canbin.length; i++) {
            let index = this.cabinarr.indexOf(n)
            if (k && index < 0) {
              this.cabinarr.push(n)
              this.list3 = this.cabinarr
            } else if (!k && index >= 0) {
              this.cabinarr.splice(index, 1)
            }
          }
          break
        //航空公司
        case 4:
          for (let i = 0; i < this.hkgs.length; i++) {
            let index = this.hkgsarr.indexOf(n)
            if (k && index < 0) {
              this.hkgsarr.push(n)
              this.list4 = this.hkgsarr
            } else if (!k && index >= 0) {
              this.hkgsarr.splice(index, 1)
            }
          }
          break
      }
      if (this.timearr.length > 0) {
        this.nolimitobj.seltime = false
      } else {
        this.nolimitobj.seltime = true
      }
      if (this.deparr.length > 0) {
        this.nolimitobj.seldepPlane = false
      } else {
        this.nolimitobj.seldepPlane = true
      }
      if (this.arrarr.length > 0) {
        this.nolimitobj.selarrPlane = false
      } else {
        this.nolimitobj.selarrPlane = true
      }
      // this.cabinarr.length > 0
      // 	? (this.nolimitobj.selcabin = false)
      // 	: (this.nolimitobj.selcabin = true)
      if (this.hkgsarr.length > 0) {
        this.nolimitobj.selhkgs = false
      } else {
        this.nolimitobj.selhkgs = true
      }
    },
    //不限
    nolimit(n) {
      switch (n) {
        case 'seltime':
          getfs(this.depTime)
          break
        case 'seldepPlane':
          getfs(this.depPlane)
          break
        case 'selarrPlane':
          getfs(this.arrPlane)
          break
        case 'selcabin':
          getfs(this.canbin)
          break
        case 'hkgsarr':
          getfs(this.hkgs)
          break
      }

      function getfs(m) {
        for (let i = 0; i < m.length; i++) {
          m[i].checked = false
        }
      }
    },
    clearing() {
      let arr = [
        'seltime',
        'seldepPlane',
        'selarrPlane',
        'selcabin',
        'hkgsarr',
      ]
      for (let i = 0; i < arr.length; i++) {
        this.nolimit(arr[i])
      }
    },
    //确定
    ensure() {
      let st = [
        this.depTime,
        this.depPlane,
        this.arrPlane,
        // this.canbin,
        this.hkgs,
      ]
      for (let i = 0, t = [0, 1, 2, 4]; i < t.length; i++) {
        for (let j = 0; j < st[i].length; j++) {
          this.getTerm(t[i], st[i][j].name, st[i][j].checked)
        }
      }
      let flightList = this.flightMap
      flightList = objToArr(flightList)
      for (let i = 0; i < flightList.length; i++) {
        flightList[i].isShow = true
      }
      if (this.tkSearchInfo.queryStrWF.travelType == 2 && this.firstFlight) {
        // 借用筛选来进行过滤航班数据的显示
        const timeStr = this.tkSearchInfo.flights[0].arriveTime
        const [hours, minutes] = timeStr.split(':')
        const date = new Date()
        // 设置时间为 09:25
        date.setHours(hours, minutes)
        // 在时间上加上两个小时
        date.setHours(date.getHours() + 2)
        // 获取新的时间字符串
        const newTimeStr = `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
        this.timearr = [newTimeStr + '-24:00']
      }
      if (this.timearr.length > 0) {
        this.nolimitobj.seltime = false
        result('departTime', this.timearr) //出发时间
      } else {
        this.nolimitobj.seltime = true
      }
      if (this.deparr.length > 0) {
        this.nolimitobj.seldepPlane = false
        result('departAirportName', this.deparr) //起飞机场
      } else {
        this.nolimitobj.seldepPlane = true
      }
      if (this.arrarr.length > 0) {
        this.nolimitobj.selarrPlane = false
        result('arriveAirportName', this.arrarr) //到达机场
      } else {
        this.nolimitobj.selarrPlane = true
      }
      // this.cabinarr.length > 0
      // 	? (this.nolimitobj.selcabin = false)
      // 	: (this.nolimitobj.selcabin = true)
      if (this.hkgsarr.length > 0) {
        this.nolimitobj.selhkgs = false
        result('airlineName', this.hkgsarr) //航空公司
      } else {
        this.nolimitobj.selhkgs = true
      }

      this.flightMap = flightList

      function result(name, arr) {
        //筛选结果
        let obj = {
          departTime() {
            flightList.forEach((el) => {
              let bl = arr.some((item) => {
                let start = item.split('-')[0]
                let end = item.split('-')[1]
                return el[name] >= start && el[name] <= end
              })
              if (!bl) {
                el.isShow = false
              }
              // if (bl) {
              // 	el.isShow = true
              // } else {
              // 	el.isShow = false
              // }
            })
          },
          departAirportName: some,
          arriveAirportName: some,
          airlineName: some,
        }
        obj[name](name, arr)
      }

      function some(name, arr) {
        flightList.forEach((el) => {
          let bl = arr.some((item) => {
            return el[name] == item
          })
          if (bl) {
            el.isShow = true
          } else {
            el.isShow = false
          }
        })
      }

      this.fliterIsShow = false
    },
    //排序
    fliters(n) {
      console.log('fl', n)
      let flightList = this.flightMap
      flightList = objToArr(flightList)
      switch (n) {
        case 1:
          if (this.v == 1 || this.v == 0) {
            this.v = 2
          } else {
            this.v = 1
          }
          this.flightMap = flightList.sort((a, b) => {
            let r = b.departTime > a.departTime
            return this.v == 1 ? (r ? 1 : -1) : r ? -1 : 1
          })
          break
        case 2:
          if (this.v == 4) {
            this.v = 3
          } else {
            this.v = 4
          }
          this.flightMap = flightList.sort((a, b) => {
            return this.v == 3
              ? b.salePrice - a.salePrice
              : a.salePrice - b.salePrice
          })
          break
      }
    },
    //返回
    back() {
      if (localStorage.getItem('home')) {
        if (isXlminp()) {
          return goXlHome()
        }

        this.$store.commit('tk/CLEAR_ALL')
        this.$store.commit('tkInt/CLEAR_ALL')
        this.$router.push({path: '/home'})
        return
      }
      this.$router.push({path: this.tkSearchInfo.backPath})
      this.$store.commit('tk/CLEAR_ALL', {})
    },
    // 火车站列表
    toTrainList() {
      Object.assign(this.trSearchInfo, {
        fromStation: this.tkSearchInfo.depport.cityName, //出发城市
        toStation: this.tkSearchInfo.arrport.cityName, //到达城市
        allTrains: true, //是否包含距发车不到2hours的车次 ,
        byTrainDate: this.tkSearchInfo.departDate.date, //乘车日期yyyy-MM-dd ,
        fromStationCode: this.tkSearchInfo.train.fromStationCode, //出发站三字编码 ,
        includePrice: true, // 是否包含票价 ，
        minRank: this.tkSearchInfo.empRank || 1, // 本次预订最低差标等级 ,
        toStationCode: this.tkSearchInfo.train.toStationCode, //目的站三字编
      })
      this.$router.push('/tr/trList')
    },
  },
  watch: {
    nolimitobj(obj) {
      for (let k in obj) {
        if (k) {
          this.nolimit(k)
        }
      }
    },
  },
}

let funs = {}

function filterflight(filters, name, fun) {
  let rules = filters[name]
  if (rules.length > 0) {
    for (let i in rules) {
      if (fun.call(this, rules[i]) === true) {
        //callfun返回true，结束循环，返回1
        return 1
      }
    }
    return -1
  }
  return 0
}

//航空公司过滤  直接在遍历 flightMap 里面筛选
funs.filterHkgs = function (filters, ft) {
  return filterflight(filters, 'hkgs', function (rule) {
    if (ft.airline == rule) {
      //只要有一个满足，返回 true
      return true
    }
  })
}
//起飞时间段过滤  直接在遍历 flightMap 里面筛选
funs.filterTimer = function (filters, ft) {
  return filterflight(filters, 'timer', function (rule) {
    let times = rule.split('-')
    if (ft.departTime >= times[0] && ft.departTime < times[1]) {
      //只要有一个满足，返回 true
      return true
    }
  })
}
//起飞机场过滤  直接在遍历 flightMap 里面筛选
funs.filterDepart = function (filters, ft) {
  return filterflight(filters, 'depart', function (rule) {
    if (ft.departAirport == rule) {
      //只要有一个满足，返回 true
      return true
    }
  })
}
//到达机场过滤  直接在遍历 flightMap 里面筛选
funs.filterArrive = function (filters, ft) {
  return filterflight(filters, 'arrive', function (rule) {
    if (ft.arriveAirport == rule) {
      //只要有一个满足，返回 true
      return true
    }
  })
}
//舱位类型过滤  在遍历 cabinTypeList 里面筛选
funs.filterCabinType = function (filters, cbt) {
  return filterflight(filters, 'cabin', function (rule) {
    if (rule.indexOf(',' + cbt.cabinType + ',') > -1) {
      //只要有一个满足，返回 true
      return true
    }
  })
}
</script>

<style lang="less" scoped>
@import '~Assets/styles/business';

.asfdsdgfhmg {
  height: 100px;
}

.tkList {
  .bor-radus {
    border-radius: 4px;
  }

  .line-height-normal {
    line-height: normal;
  }

  .pad-10 {
    padding: 10px;
  }

  .pad6 {
    padding: 6px;
  }

  .pad2 {
    padding: 2px;
  }

  .pad-t-6 {
    padding-top: 6px;
  }

  .pad-b-5 {
    padding-bottom: 5px;
  }

  .list {
    padding: 0 6px;
  }

  .icon {
    font-size: 18px;
    height: 18px;
  }

  .firstFlight {
    padding: 0 6px 5px;

    span {
      display: inline-block;
      width: 16px;
      height: 16px;
      line-height: 16px;
      background-color: @color-background-green;
      font-size: @font-size-12;
      text-align: center;
      color: @color-text-white;
    }
  }

  .tkListwrapper {
    height: calc(100vh - 140px);
    overflow: hidden;

    .callMe {
      position: relative;
      bottom: 50px;

      img {
        position: absolute;
        top: 11px;
      }

      span {
        position: absolute;
        bottom: -38px;
        right: 10px;
        display: inline-block;
        width: 18px;
        border: 0.5px solid #fff;
        border-radius: 50%;
        color: #fff;
        text-align: center;
        font-size: 12px;
      }
    }
  }

  // 展示时间等其他东西
  .nav {
    width: 100%;
    height: 55px;
    background-color: #fff;
  }

  .navlist {
    width: 100%;
    height: calc(100%); //动态计算长度值
    overflow-y: scroll;
    overflow-x: hidden;

    span {
      width: 100px;
      height: 39px;
      text-align: center;
      margin: -10px 10px -10px 10px;
      background-color: #ccc;
      border-radius: 10px;
      position: relative;
      top: 18px;
      line-height: 39px;
    }
  }

  .flexStyle {
    height: 47px;
    display: flex;
    justify-content: flex-start;
    overflow-x: auto;
  }

  .contentStyle {
    width: 50px;
    height: 50px;
    display: inline-block;
    background: #a3a2a2;
    margin-right: 5px;
    /* 超出滚动的关键，没有它元素会自动缩小，不会滚动 */
    flex-shrink: 0;
  }

  ::-webkit-scrollbar {
    /* 隐藏滚动条 */
    display: none;
  }
}
.font_col_ss{
  font-size: 14px;
    // font-weight: 600;
    color: #c8c9cc;
  }
  .width_padd{
    padding: 24% 2%;
    text-align: center;
}
</style>
